export enum PaginationFields {
  NEXT = 'next',
  PREV = 'prev',
  LIMIT = 'limit',
  CURSOR = 'cursor',
}

export interface IPaginationDTO {
  [PaginationFields.CURSOR]?: string;
  [PaginationFields.LIMIT]?: number;
}

export interface IPaginationResponse {
  [PaginationFields.NEXT]?: string | null;
  [PaginationFields.PREV]?: string | null;
}

export interface IPagination {
  [PaginationFields.NEXT]?: string | null;
  [PaginationFields.PREV]?: string | null;
  [PaginationFields.LIMIT]?: number;
}
